import React, { Component } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import { http } from '../helper';
import DataTable from 'react-data-table-component';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import { canAction } from '../common/permissionhelper';
class Accountcode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTextVal: "",
            accountcodelist: [],
            templist: [],
            loading: true,
            visibleAlert: false,
            accountcodevalue: '',
        };

        if (!sessionStorage.getItem("isLoggedIn")) {
            window.location.href = '/';
        }

        if (JSON.parse(sessionStorage.getItem('authData')) !== '' &&
            !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_masterentry')) {
            window.location.href = '/unauthorized';
        }
    }

    componentDidMount() {
        this.getAccountcodelist();
    }

    getAccountcodelist() {
        const URL = BaseUrl + "admin/accountcodelist";
        http.get(URL).then((response) => {
            this.setState({
                accountcodelist: response.data.data,
                loading: false,
                templist: response.data.data
            });
        }).catch((err) => {
            console.log(err);
        });
    }

    handleChange = (value) => {
        this.setState({ searchTextVal: value });
        this.filterData(value);
    };

    filterData = (value) => {
        const accoun = this.state.templist;
        const lowercasedValue = value.toLowerCase().trim();
        let result = [];

        if (lowercasedValue.length > 0) {
            accoun.forEach(item => {
                if ((item.accountCode ?? '').toString().toLowerCase().includes(lowercasedValue)) {
                    result.push(item);
                }
            });
            this.setState({ accountcodelist: result });
        } else {
            this.setState({ accountcodelist: accoun });
        }
    };


    handleReset = () => {
        this.setState({ searchTextVal: '', accountcodelist: this.state.templist });
    };

    addaccountcode = () => {
        window.location.href = '/restrictedaccountcode/accountcode/add/';
    };
    editaccountcode = (value) => {
        window.location.href = `/restrictedaccountcode/accountcode/edit/${value._id}/`;
    };

    deleteAccountcode = (value) => {
        this.setState({ visibleAlert: true, accountcodevalue: value });
    };

    deleteAccountcodeValue = () => {
        const URL = BaseUrl + `admin/accountcode/${this.state.accountcodevalue._id}`;
        http.delete(URL).then((response) => {
            if (response.data.success === true) {
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    alertPopupclose = () => {
        this.setState({ visibleAlert: false, accountcodevalue: '' });
    };

    render() {
        const columns = [
            {
                name: "Account Code",
                selector: row => row.accountCode,
                sortable: true,
            },
            {
                name: "Actions",
                selector: row => {
                    const canEdit = canAction('manage_masterentry', 'edit');
                    return (
                        <div style={{ display: "flex" }}>
                            <a
                                className='button title-tooltip title-up'
                                data-title={canEdit ? 'Edit' : 'View'}
                                style={{ color: "white" }}
                                onClick={() => this.editaccountcode(row)}
                            >
                                <i className={`fa ${canEdit ? 'fa-pencil' : 'fa-eye'}`} aria-hidden="true"></i>
                            </a>

                            {canAction('manage_masterentry', 'delete') && (
                                <a
                                    className='button title-tooltip title-up'
                                    data-title='Delete'
                                    style={{ color: "white" }}
                                    onClick={() => this.deleteAccountcode(row)}
                                >
                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                </a>
                            )}
                        </div>
                    )
                },
                sortable: false,
            }
        ];

        const customStyles = {
            rows: { style: { minHeight: '25px' } },
            headCells: { style: { padding: '8px' } },
            cells: { style: { padding: '8px' } },
        };

        const paginationComponentOptions = {
            rowsPerPageText: '',
            rangeSeparatorText: '',
            selectAllRowsItem: true,
            selectAllRowsItemText: '',
            noRowsPerPage: '',
        };

        return (
            <>
                <div className="dashboard-block">
                    <Sidebar />
                    <div className="dash-left">
                        <Header />

                        <section className="cart-block">
                            <div className="container">
                                <h1 className="checkout-title">Restricted Accounts</h1>

                                <div className="right-table-outer-wrap">
                                    <div className="table-filter search-orders">
                                        <div className='table-search-reset'>
                                            <div className="table-search">
                                                <input
                                                    type="text"
                                                    value={this.state.searchTextVal}
                                                    onChange={e => this.handleChange(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search by Code"
                                                />
                                            </div>
                                            <button
                                                className='submitbtn button search-holi-btn'
                                                onClick={() => this.filterData(this.state.searchTextVal)}>
                                                <i className="fa fa-search"></i>
                                            </button>
                                            <button className='resetbtn' type='reset' onClick={this.handleReset}>Reset</button>
                                        </div>
                                        {canAction('manage_masterentry', 'add') && (
                                        <div className='add-holidaybtn'>
                                            <button className='addbtn' onClick={this.addaccountcode}>Add</button>
                                        </div>
                                        )}
                                    </div>
                                    <p className="note-text">
                                        Note: Orders from Restricted Accounts are excluded from all dashboard sales totals and financial reports.
                                    </p><br />
                                    <div className="table_overflow">
                                        <DataTable
                                            columns={columns}
                                             noDataComponent={<div className='no-records-found'>Sorry, no account code were matching your keyword, try a new search.</div>}
                                            data={this.state.accountcodelist}
                                            customStyles={customStyles}
                                            pagination
                                            paginationPerPage={25}
                                            progressPending={this.state.loading}
                                            paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                            paginationComponentOptions={paginationComponentOptions}
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>

                {this.state.visibleAlert &&
                    <div className='custom-alert-pop paylater-popup'>
                        <div className='custom-alert-container'>
                            <div className='custom-alert-wrap'>
                                <div className='custom-alert-header'>
                                    <h4>Alert</h4>
                                </div>
                                <div className='custom-alert-body'>
                                    <p>Are you sure you want to delete?</p>
                                    <div className='alert-buttons'>
                                        <a onClick={this.deleteAccountcodeValue} className="popup-alert-btn button">OK</a>
                                        <a onClick={this.alertPopupclose} className="popup-alert-btn button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
            </>
        );
    }
}

export default Accountcode;
